<template>
  <div id="import-order">
    <div class="import-panel">
      <div class="import-title">批量导入名单</div>
      <ul>
        <li>导入文件格式必须为Excel，后缀为 .xls 或 .xlsx</li>
        <li>每个订单最多导入200名申请人，多余部分请生成新订单重新导入</li>
        <li>
          请务必设置表格首行列标题为“申请人姓名”和“旅客身份”，具体内容格式可参考模板
          <a href="https://o.666visa.cn/static/ssqpeer/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx">下载模板</a>
        </li>
      </ul>
    </div>

    <div class="import-tips" v-if="getIdentitys(product, currentFlow).length < 5 && getIdentitys(product, currentFlow)[0] !== 5">
      <div class="support">
        *该商品支持的旅客身份:
        <span v-for="(identity, index) in getIdentitys(product, currentFlow)" :key="index">{{identitys[identity]}}
          <template v-if="index < (getIdentitys(product, currentFlow).length - 1)">、</template>
        </span>
      </div>
    </div>

    <div class="import-tips" v-if="getIdentitys(product, currentFlow).length === 1 && getIdentitys(product, currentFlow)[0] === 5">
      <div class="support">
        *该商品支持所有旅客身份，表格内“旅客身份”项可不填
      </div>
    </div>

    <div class="import-action">
      <input type="file" class="faraway import-file" accept=".xls,.xlsx" @change="importChange">
      <el-button type="primary" @click="importSelect" :loading="importing">选择文件</el-button>
      <el-button type="default" @click="closeImport">&nbsp;&nbsp;&nbsp;返回&nbsp;&nbsp;&nbsp;</el-button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { IMPORT_NEW_ORDER_APPLICANTS } from '../../store/modules/order/order-mutation-types';
import status from '../../libs/status';
import utils from '../../libs/utils';
import addNewOrderService from '../../services/add-new-order-service';
import Http from '../../libs/http';
import User from '../../libs/user';
import _ from 'lodash';

export default {
  name: 'importOrder',
  props: {
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    order: {
      type: Object,
      default() {
        return {};
      },
    },
    currentFlow: {
      type: Number,
    },
  },
  data() {
    return {
      identitys: status.identity,
      importing: false, // 导入中
    };
  },
  computed: {
    // 是否是通用商品
    isUniversalIdentity() {
      if (this.product && this.product.material && this.product.material[0]) {
        return this.product.material[0].identity_id === 5;
      }
      return false;

    },
  },
  methods: {
    ...mapMutations('order/', [
      IMPORT_NEW_ORDER_APPLICANTS,
    ]),

    getIdentitys: addNewOrderService.getIdentitys,

    // 选择文件发生变化
    importChange(e) {
      if (!e.target.files[0]) return;
      this.importing = true;
      const file = e.target.files[0];

      if (file.size >= 10240000) {
        this.importing = false;
        e.target.value = '';
        return utils.msg.warning('名单文件必须小于10M');
      }

      const fileReader = new FileReader();
      fileReader.onload = () => {
        e.target.value = '';

        try {
          const sheets = XLSX.read(fileReader.result, { type: 'binary' }).Sheets;

          if (!sheets['上上签申请人名单模板']) {
            this.importing = false;
            return utils.msg.error('无法识别表格内容，请参照文档模板进行填写');
          }

          this.importAction(sheets['上上签申请人名单模板']);
        } catch (err) {
          this.importing = false;
          utils.msg.error('名单导入失败，请参照模板格式重新导入');
        }
      };
      fileReader.readAsBinaryString(file);
    },

    // 点击导入
    importSelect() {
      if (!window.XLSX) return utils.msg.error('引入解析模块失败');
      this.$el.querySelector('.import-file').click();
    },

    // 导入
    importAction(sheets) {
      let errs = 0;

      if (!sheets.A1 || sheets.A1.w !== '申请人姓名') errs = 1;
      if (!sheets.B1 || sheets.B1.w !== '旅客身份') errs = 1;
      if (sheets.C1 && sheets.C1.w.indexOf('旅客身份可下拉选择') < 0) errs = 1;

      if (errs) {
        this.importing = false;
        return utils.msg.error('无法识别表格内容，请参照文档模板进行填写');
      }

      const identityMap = {
        在职人员: 0,
        自由职业者: 1,
        退休人员: 2,
        在校学生: 3,
        学龄前儿童: 4,
        通用身份: 5,
      };

      const xlsData = {};
      const errRows = [];

      Object.keys(sheets).forEach((key) => {
        if (/^A\d+$/.test(key)) {
          const n = +key.replace(/\D/g, '');

          if (n > 1) {
            xlsData[n] = xlsData[n] || {};
            xlsData[n].applicant_name = sheets[key].w
              ? sheets[key].w.trim()
              : '';
            xlsData[n].applicant_name = xlsData[n].applicant_name.substr(0, 15);
          }
        }

        if (/^B\d+$/.test(key)) {
          const i = +key.replace(/\D/g, '');
          if (i > 1) {
            xlsData[i] = xlsData[i] || {};
            xlsData[i].identity_id = sheets[key].w ? sheets[key].w.trim() : '';
          }
        }
      });

      this.importing = false;

      if (!Object.keys(xlsData).length) {
        return utils.msg.warning('未导入任何申请人，请将信息填入表格');
      }

      const identities = addNewOrderService.getIdentitys(this.product, this.currentFlow);

      Object.keys(xlsData).forEach((row, k) => {
        if (k > 199) {
          return;
        }

        const ap = xlsData[row];

        if (!ap.applicant_name) {
          return errRows.push(row);
        }

        // 在非通用身份时，校验身份是否合法
        if (
          !this.isUniversalIdentity && ap.identity_id &&
          (identityMap[ap.identity_id] === undefined ||
            identities.indexOf(identityMap[ap.identity_id]) < 0)
        ) {
          return errRows.push(row);
        }

        // 如果是通用身份，直接设置身份id为5
        if (this.isUniversalIdentity) {
          xlsData[row].identity_id = 5;
        } else if (ap.identity_id) {
          xlsData[row].identity_id = identityMap[ap.identity_id];
        } else {
          // 如果当前商品支持在职人员，则赋值为0，否则直接报错
          if (identities.indexOf(0) > -1) {
            xlsData[row].identity_id = 0;
          } else {
            return errRows.push(row);
          }
        }
      });

      if (errRows.length) {
        if (Object.keys(xlsData).length <= 200) {
          utils.msgbox.alert(
            `第${errRows.join('、')}行信息有误，请检查并修改后重新上传`,
            '提示',
            { confirmButtonText: '知道了' },
          );
        } else {
          utils.msgbox.alert(
            `前200位申请人中，第${errRows.join(
              '、',
            )}行信息有误，请修改后重新上传；其余申请人重新导入`,
            '提示',
            { confirmButtonText: '知道了' },
          );
        }

        return;
      }

      // 订单内已有申请人数量
      const isHaveApplicant = this.order.applicant ? this.order.applicant.length : 0;

      const applicants = Object.keys(xlsData)
        .map(k => xlsData[k])
        .slice(0, (200 - isHaveApplicant));

      this.IMPORT_NEW_ORDER_APPLICANTS({ applicants });

      if (Object.keys(xlsData).length <= 200) {
        utils.msg.success(`成功导入${applicants.length}位申请人`);
      } else {
        utils.msgbox.alert(
          '前200位申请人已导入成功，其余申请人请生成新订单重新导入',
          '申请人数超过上限',
          { confirmButtonText: '知道了' },
        );
      }

      this.$emit('success', {
        applicants: _.clone(applicants),
      });

      // 工单埋点
      this.workOrderRecord();

      this.closeImport();
    },

    closeImport() {
      this.$emit('closeImport');
    },
    // 工单埋点
    workOrderRecord() {
      // 销帮帮记录埋点
      if (User.isLogin()) {
        Http.post('/peer_behavior_record_add', {
          visa_product_id: this.product.visa_product_id, 
          behavior_type_id: 10003, // 10001:浏览商品列表页, 10002:浏览商详页, 10003:添加申请人, 10007:分享商详页, 10008:分享店铺
        });
      }
    },
  },
  created() {
    if (!window.XLSX) {
      utils.jsLoad('https://o.666visa.cn/static/xlsx.core.min.js');
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/variable";

#import-order {
  margin-top: -5px;

  .import-panel {
    background-color: #f7f8fa;
    padding: 15px 20px;
  }

  ul {
    list-style-type: disc;
    padding-left: 20px;
    margin-top: 12px;
  }

  li {
    margin-top: 4px;
    color: #444;
    font-size: 14px;
    line-height: 1.7;

    a {
      color: @link;
      margin-left: 5px;
      text-decoration: underline;
    }
  }

  .import-tips {
    margin: 5px 0 18px 0;
    color: #444;
    line-height: 1.6;
    font-size: 14px;
    .support {
      display: inline-block;
      white-space: nowrap;
      color: #ff5a60;
    }
  }

  .import-title {
    font-size: 14px;
    margin-bottom: 8px;
    color: #333;
    font-weight: 500;
  }

  .import-action {
    text-align: right;
    margin-top: 22px;

    .el-button {
      width: 120px;
      height: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/add-order/import-order.vue